<div class="screen-container text-light text-center pt-5">
    <h1 class="display-3" translate>room.student.finish.title</h1>
    <h5 [innerHTML]="'room.student.finish.message' | translate"></h5>
</div>
